export default "/assets/images/air-changes-graph-sm.927a022fc1fa3c8e.svg";